import React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function TransactionStatusNode({
  row,
  fullWidthAction = false,
  onCompleteRemainingPayment,
}) {
  if (!row) return null;

  if (row.status === "EXPIRED") {
    return (
      <Box
        sx={{
          padding: "4px 12px",
          bgcolor: `#eeeeee`,
          color: `#444`,
          borderRadius: "18px",
          width: "fit-content",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography style={{ fontSize: "12px" }} variant="body2">
          Expired
        </Typography>
      </Box>
    );
  }

  if (row.status === "CREATED") {
    return (
      <Box
        sx={{
          padding: "4px 12px",
          bgcolor: `#fbf4e0`,
          color: `#975e0a`,
          borderRadius: "18px",
          width: "fit-content",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography style={{ fontSize: "12px" }} variant="body2">
          Payment Pending
        </Typography>
      </Box>
    );
  }

  if (row.status === "PARTPAID" && row?.newpaymentMade) {
    return (
      <Box
        sx={{
          padding: "4px 12px",
          bgcolor: `#fbf4e0`,
          color: `#975e0a`,
          borderRadius: "18px",
          width: "fit-content",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography style={{ fontSize: "12px" }} variant="body2">
          Verification Pending
        </Typography>
      </Box>
    );
  }

  if (
    row.status === "PARTPAID" &&
    row?.pendingAmt > 0 &&
    !row?.newpaymentMade
  ) {
    return (
      <Button
        fullWidth={fullWidthAction}
        style={{ padding: "10px", fontSize: "12px" }}
        onClick={() => onCompleteRemainingPayment?.(row)}
        variant="outlined"
      >
        Complete Remaining Payment
      </Button>
    );
  }

  if (row.status === "APPROVED" || row.status === "FRAXTRANSFERED") {
    return (
      <Box
        sx={{
          padding: "4px 12px",
          bgcolor: `success.light`,
          color: `success.main`,
          borderRadius: "18px",
          width: "fit-content",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography style={{ fontSize: "12px" }} variant="body2">
          Payment Completed
        </Typography>
      </Box>
    );
  }

  if (row.status === "REFUNDED") {
    return row.isRefunded ? (
      <Box
        sx={{
          padding: "4px 12px",
          bgcolor: `#fbf4e0`,
          color: `#975e0a`,
          borderRadius: "18px",
          width: "fit-content",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography style={{ fontSize: "12px" }} variant="body2">
          Payment Refunded
        </Typography>
      </Box>
    ) : (
      <Box
        sx={{
          padding: "4px 12px",
          bgcolor: `#dddddd`,
          color: `#000000`,
          borderRadius: "18px",
          width: "fit-content",
        }}
      >
        <Typography style={{ fontSize: "12px" }} variant="body2">
          Refund Pending
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: "4px 12px",
        bgcolor: `#ffdfdf`,
        color: `#df0a0a`,
        borderRadius: "18px",
        width: "fit-content",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Typography style={{ fontSize: "12px" }} variant="body2">
        Payment Rejected
      </Typography>
    </Box>
  );
}

